import { createRouter, createWebHistory } from "vue-router";
import LoginPage from "@/views/softwares/common/LoginPage.vue";

const router = createRouter({
  history: createWebHistory(""),
  routes: [
    {
      path: "/",
      name: "Login",
      component: LoginPage,
      alias: "/login",
    },
    {
      path: "/admin/payResult",
      name: "PayResult",
      meta: { requiresAuth: true },
      component: () => import("@/views/softwares/common/paymentResult.vue"),
    },
    {
      path: "/overview",
      name: "CommandDesk",
      meta: { requiresAuth: true },
      component: () => import("../pages/CommandDesk.vue"),
      children: [
        {
          path: "",
          name: "OverviewDashboard",
          component: () => import("../pages/OverviewDashboard.vue"),
        },
        {
          path: ":software/:page",
          name: "SoftwarePage",
          component: () => import("../pages/SoftwarePage.vue"),
        },
      ],
    },
    {
      path: "/test",
      name: "Test",
      component: () => import("../pages/Test.vue"),
    },
    {
      path: "/buyer",
      name: "Buyer",
      redirect: "/overview/ESF/Buyers",
    },
    {
      path: "/company-setup",
      redirect: "/overview/ESF/Buyers",
    },
    { path: "/:pathMatch(.*)*", redirect: "/overview" },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    if (to.hash) return { el: to.hash, behavior: "smooth" };
    return { top: 0 };
  },
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("token");
  if (to.matched.some((record) => record.meta.requiresAuth) && !token) {
    next({ path: "/login" });
    return;
  }
  if (to.name === "Login" && token) {
    next("/overview");
    return;
  }
  next();
});

router.beforeEach((to, from, next) => {
  try {
    const companyActive = localStorage.getItem("companyisactive");
    const companySetupPath = "/overview/ESF/Buyers";
    const allowedInactiveCompanyPaths = [
      companySetupPath,
      "/overview/common/user-area",
      "/overview/common/notifications-center",
      "/overview/ESF/Buyers",
      "/overview/ESF/dashboard",
      "/overview/ESF/CompanyGoodsAndService",
      "/overview/ESF/CompanyUnit",
      "/overview/ESF/EStatement",
      "/overview/ESF/ESFsettings",
      "/overview/ESF/PrintPage",
      "/overview/ESF/PrintGoldPage",
      "/overview/ESF/ReportPage",
      "/overview/clinic/dashboard",
      "/overview/clinic/definitions",
      "/overview/clinic/doctors",
      "/overview/clinic/invoice",
      "/overview/clinic/patients",
      "/overview/clinic/reception",
      "/overview/clinic/receptionlist",
      "/overview/clinic/reports",
      "/overview/clinic/services",
      "/overview/clinic/store",
      "/overview/clinic/users",
    ];
    if (
      to.fullPath.startsWith("/overview") &&
      companyActive === "false" &&
      !allowedInactiveCompanyPaths.includes(to.path)
    ) {
      next(companySetupPath);
      return;
    }
  } catch (e) {
    // Ignore localStorage access errors.
  }
  next();
});

export default router;
